// These strings must match the NotificationTypes strings being sent from the API,
// usually sent in NotificationBusinessLogic.

export enum HubConnectionName {
	SurveyParticipantCountsChange = 'surveyParticipantCountsChange',
	SurveyDeleteChange = 'surveyDeleteChange',
}
